module.exports = __webpack_public_path__ + "img/Scream-Music-Composer2.d55fe2f1.png";